import React, { Component } from 'react';

export const LoaderComp = ({color = 'white'}) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid" className="lds-rolling" style={{background: 'none'}}>
        <circle cx="50" cy="50" fill="none" stroke={color} strokeWidth="10"   r="35" strokeDasharray="164.93361431346415 56.97787143782138" transform="rotate(269.225 50 50)">
            <animateTransform attributeName="transform" type="rotate" calcMode="linear" values="0 50 50;360 50 50" keyTimes="0;1" dur="1s" begin="0s" repeatCount="indefinite"/>
        </circle>
    </svg>
)


// WEBPACK FOOTER //
// ./src/_components/common/LoaderComp/Loadercomp.js